import React from 'react'


const Footer = () => (
  
<footer style={{textAlign:'center', position:'relative', bottom:'0', alignLeft:'auto' }} className='my-5'>
          © {new Date().getFullYear()}  Naren Katakam. 
          {` `}
            All rights reserved.
          <p>If you wish to take content from this website, I'd appreciate if you give an appropriate line of credit and link back to this website.</p>
        </footer>
)        

export default Footer      